import React from "react"
import { Container, Row, Col } from "reactstrap"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image";
import WPLink from "components/shared/WPLink"
import BlockTitle from "components/shared/BlockTitle"
import { LinkSearchReplace } from "utils/LinkSearchReplace"

const Content = styled.div`
    p {
        &:last-child {
            margin: 0;
        }
    }
`

const ColumnedImageText = (props) => {
    const { block } = props
    const size = block.columnAmount === "2" ? 6 : 4

    return (
        <Container className="pt-4">
            {block.title && 
                <BlockTitle>{block.title}</BlockTitle>
            }
            <Row className="justify-content-center">
                {block.blocks && block.blocks.map((item, i) => {
                    return (
                        <Col xs={12} md={size} key={i} className="pb-4">
                            {item.image && 
                                <GatsbyImage
                                    image={item.image.localFile.childImageSharp.gatsbyImageData}
                                    alt={item.image.altText} /> 
                            }
                            {item.title && 
                                <BlockTitle className="text-center">{item.title}</BlockTitle> 
                            }
                            {item.text &&  
                                <Content dangerouslySetInnerHTML={{ __html: LinkSearchReplace(item.text) }} /> 
                            }
                            {item.link &&  
                                <WPLink url={item.link.url} target={item.link.target} button className="mt-4">{item.link.title}</WPLink> 
                            }
                        </Col>
                    );
                })}
            </Row>
            {block.link &&  
                <div className="text-center">
                    <WPLink url={block.link.url} target={block.link.target} button className="my-4">{block.link.title}</WPLink> 
                </div>
            }
        </Container>
    );
}

export default ColumnedImageText

ColumnedImageText.defaultProps = {
    padding: true
}